import React from 'react';
import './ChangeRequestSummary.less';
import ChangeRequestAnalysis from '../ChangeRequestAnalysis/ChangeRequestAnalysis';
import ChangeRequestActions from '../ChangeRequestActions/ChangeRequestActions';

const ChangeRequestSummary: React.FC = () => {
  // Render the summary page.
  return (
    <div id="change-request-summary">
      <p className="bold-text">Analysis</p>
      <ChangeRequestAnalysis />
      <p className="bold-text">Actions</p>
      <ChangeRequestActions />
    </div>
  );
};

export default ChangeRequestSummary;
